// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.phantom",
    name: "Phantom",
    homepage: "https://phantom.app/",
    image_id: "c38443bb-b3c1-4697-e569-408de3fcc100",
    app: {
        browser: null,
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
        firefox: "https://addons.mozilla.org/en-US/firefox/addon/phantom-app/",
        safari: null,
        edge: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
        opera: null,
    },
    rdns: "app.phantom",
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map